import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import { SearchOutline } from '@olist/design-system-icons';
import { Wrapper, StyledInput, SearchCancelButton, SearchCancelIcon, CtaButton } from './styles.js';
import { useDebounce } from '../../hooks/useDebounce.js';
import { WrapperInput } from '../Input/styles.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const DEFAULT_DEBOUNCE_DELAY = 600;
const InputSearch = forwardRef((_a, ref) => {
    var { debounceDelay = DEFAULT_DEBOUNCE_DELAY, placeholder, feedback, isLoading, onClean, onSearch, disabled, value, ctaButton, helperText, readOnly, ctaButtonText = 'buscar', margin, marginTop, marginBottom, marginRight, marginLeft, marginHorizontal, marginVertical, m, mt, mr, mb, ml, mx, my } = _a, props = __rest(_a, ["debounceDelay", "placeholder", "feedback", "isLoading", "onClean", "onSearch", "disabled", "value", "ctaButton", "helperText", "readOnly", "ctaButtonText", "margin", "marginTop", "marginBottom", "marginRight", "marginLeft", "marginHorizontal", "marginVertical", "m", "mt", "mr", "mb", "ml", "mx", "my"]);
    const inputRef = useRef(null);
    const debouncedOnSearch = useDebounce(onSearch, debounceDelay);
    useImperativeHandle(ref, () => inputRef.current);
    useEffect(() => {
        if (value && !ctaButton) {
            debouncedOnSearch(value);
        }
    }, [value, debouncedOnSearch]);
    function handleClean() {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onClean();
    }
    function handleSearchClick() {
        onSearch(value);
    }
    return (React.createElement(Wrapper, Object.assign({ hasCtaButton: ctaButton }, {
        margin,
        marginTop,
        marginBottom,
        marginRight,
        marginLeft,
        marginHorizontal,
        marginVertical,
        m,
        mt,
        mr,
        mb,
        ml,
        mx,
        my,
    }),
        React.createElement(WrapperInput, { disabled: disabled, feedback: feedback, readOnly: readOnly, isLoading: isLoading },
            React.createElement(StyledInput, Object.assign({}, props, { ref: inputRef, value: value, prefix: SearchOutline, feedback: feedback, isLoading: isLoading, placeholder: placeholder, disabled: disabled, readOnly: readOnly, type: "search", suffix: value &&
                    !isLoading &&
                    !feedback && (React.createElement(SearchCancelButton, { tabIndex: -1, "aria-hidden": true, onClick: handleClean },
                    React.createElement(SearchCancelIcon, null))) })),
            ctaButton && (React.createElement(CtaButton, { size: "medium", onClick: handleSearchClick, disabled: disabled || isLoading, "aria-readonly": readOnly }, ctaButtonText))),
        helperText && React.createElement(Caption, null, helperText)));
});
InputSearch.displayName = 'InputSearch';

export { DEFAULT_DEBOUNCE_DELAY, InputSearch };
